import { Grid, Paper, Typography, styled } from "@mui/material";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Link } from "react-router-dom";

interface GridInterfaceMara {
    img: string;
    head: string;
    desc: string;
    url: string;
}

export default function GridStyleMara(data: any) {

    var ndata = data.data as GridInterfaceMara[];

    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: "transparent",
        textAlign: 'left',
        boxShadow: "none",
        padding: "15px"
    }));

    const GridItem = (item: GridInterfaceMara) => {
        return (
            <Grid item xs={12} sm={6} lg={3} key={item.head}>
                <Item style={{ textAlign: "left" }}>
                    <Typography variant="h5" component="div" sx={{
                        flexGrow: 1,
                        marginBottom: "20px", textAlign: "left"
                    }}>
                        {item.head}
                    </Typography>
                    <img src={item.img} alt={item.head} style={{ marginBottom: "15px", width: "100%" }} />
                    <Typography variant="body1" component="div" sx={{
                        flexGrow: 1, overflow: 'hidden',
                        textAlign: "justify",
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: '10',
                        WebkitBoxOrient: 'vertical',
                    }}>
                        {item.desc}
                    </Typography>
                    <Link to={item.url} style={{ textDecoration: "none" }}>
                        <Typography variant="body1" component="div" sx={{
                            flexGrow: 1,
                            textAlign: "left",
                            marginTop: "10px",
                            fontStyle: "italic",
                            position: 'relative',
                            color: "#000000",
                            cursor: "pointer",
                            display: "inline-block",
                            fontSize: "14px",
                            '&::after': {
                                content: '""',
                                height: "2px",
                                position: "absolute",
                                background: "#00896f",
                                left: "-9px",
                                right: "-25px",
                                bottom: "-10px",
                            },
                            '&:hover': {
                                color: "#00896f",
                            }
                        }}>
                            Read More <ArrowForwardIosIcon style={{ fontSize: 12 }} />
                        </Typography>
                    </Link>
                </Item>
            </Grid>
        );
    }

    return (
        <div style={{ backgroundColor: data.backgroundcolor, paddingTop: "30px", paddingBottom: "30px" }}>
            <Typography variant="h5" component="div" sx={{
                flexGrow: 1,
                marginBottom: "30px",
                textAlign: "center",
                fontWeight: "bold",
                position: "relative",
                '&::after': {
                    content: '""',
                    height: "2px",
                    position: "absolute",
                    background: "#00896f",
                    left: "50%",
                    marginLeft: "-35px",
                    bottom: "-15px",
                    width: "70px"
                }
            }}>
                {data.title}
            </Typography>
            <Grid container maxWidth={"1300px"} margin={"auto"}>
                {
                    ndata.map(dataitem => GridItem(dataitem))
                }
            </Grid>
        </div>
    );
};
